import React from 'react';
import PropTypes from 'prop-types';

import Textinput from './textinput';
import ProductSelector from './productSelector';
import { isIntegerValid, isEveryValid, isLengthValid } from '../services/utils';
import { CustomViewType } from '../constants/customViews';
import { OrderStatuses, Intents } from '../constants/order';
import { ContractTypes } from '../constants/contract';

const getProductIds = ids => ids.filter(id => id !== '').map(id => +id);

const fillProductList = products =>
    ['', '', '', '', '', ''].map((item, i) => (products[i] ? products[i].toString() : ''));

class ManageTabPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            view_id: '',
            order: '',
            product_ids: ['', '', '', '', '', ''],
            num_rows: '18',
            validation: {
                name: false,
                order: false,
                product_ids: false,
                num_rows: true,
            },
            submitClicked: false,
            nameExist: false,
        };
    }

    componentDidMount() {
        if (this.props.mode === 'update') {
            this.fillForm();
        }
    }

    closePopup = e => {
        if (e.target.getAttribute('name') === 'manageTabPopup') {
            this.props.hidePopup();
        }
    };

    handleSubmit = e => {
        e.preventDefault();

        const isNameExist = this.props.views.some(
            view => view.name === this.state.name && view.id !== this.state.view_id,
        );
        const productIds = getProductIds(this.state.product_ids);
        const validation = {
            ...this.state.validation,
            product_ids: productIds.length !== 0,
        };

        this.setState({
            ...this.state,
            submitClicked: true,
            nameExist: isNameExist,
            validation,
        });

        const isValid = isEveryValid(validation) && !isNameExist;
        if (isValid) {
            const additionalData = this.props.mode === 'update' ? { id: this.state.view_id } : {};
            const params = {
                ...additionalData,
                name: this.state.name,
                args: {
                    order: +this.state.order,
                    num_rows: +this.state.num_rows,
                    include: {
                        contract_type: [ContractTypes.OTC, ContractTypes.CME, ContractTypes.PHYSICAL],
                        status: [OrderStatuses.OPEN, OrderStatuses.EXPIRED, OrderStatuses.CLOSED],
                        products: productIds,
                        intents: [Intents.SELL, Intents.BUY],
                    },
                    sort_order: 'ascending',
                    sort_by: 'update_time',
                },
                user_id: this.props.user.id,
                view_type: CustomViewType.GRID,
            };
            this.props.saveView(this.props.mode, params, CustomViewType.GRID);
        }
    };

    validateField = (fieldName, value) => {
        let isValid = true;

        if (this.state.validation[fieldName] === undefined) {
            return;
        }

        if (fieldName === 'name') {
            isValid = isLengthValid(value, fieldName);
        } else if (fieldName === 'order') {
            isValid = isIntegerValid(value);
        }

        this.setState({
            validation: {
                ...this.state.validation,
                [fieldName]: !!isValid,
            },
        });
    };

    validateProductField = () => {
        const productIds = getProductIds(this.state.product_ids);
        this.setState({
            validation: {
                ...this.state.validation,
                product_ids: productIds.length !== 0,
            },
        });
    };

    handleProductChange = e => {
        const { name, value } = e.target;

        const { product_ids } = this.state;
        product_ids[+name.substr(name.length - 1)] = value;

        this.setState({ product_ids }, () => {
            this.validateProductField(name, value);
        });
    };

    fillForm = () => {
        const { data } = this.props;
        const product_ids = fillProductList(data.args.include.products);

        this.setState({
            ...this.state,
            name: data.name,
            order: data.args.order,
            num_rows: data.args.num_rows,
            view_id: data.id,
            product_ids,
            validation: {
                name: !!data.name,
                order: !!data.args.order,
                num_rows: !!data.args.num_rows,
                product_ids: !!product_ids,
            },
        });
    };

    handleChange = e => {
        const { name, value } = e.target;

        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    };

    render() {
        const { mode } = this.props;
        const { submitClicked } = this.state;

        return (
            <div
                onClick={this.closePopup}
                name="manageTabPopup"
                className="admin-taps-container generic-popup-container"
            >
                <form className="admin-tap-inner">
                    <center>
                        <h2 className="title"> {mode === 'create' ? 'Create' : 'Update'} tab</h2>
                    </center>

                    <Textinput
                        label="Tab name"
                        name="name"
                        value={this.state.name}
                        onChange={this.handleChange}
                        required
                        invalid={(!this.state.validation.name || this.state.nameExist) && submitClicked}
                        type="text"
                    />

                    {this.state.nameExist ? (
                        <p className="error">This name already exists. Please choose another name. </p>
                    ) : null}

                    <Textinput
                        label="Order"
                        name="order"
                        value={this.state.order}
                        onChange={this.handleChange}
                        required
                        invalid={!this.state.validation.order && submitClicked}
                        type="text"
                    />

                    {!this.state.validation.order && submitClicked ? (
                        <p className="error">Must be a positive number. </p>
                    ) : null}

                    <div
                        className={`manage-taps-selector-products ${
                            !this.state.validation.product_ids && submitClicked ? 'error' : ''
                        }`}
                    >
                        {this.state.product_ids.map((product_id, index) => (
                            <ProductSelector
                                key={`${index}_${product_id}`}
                                name={`product_id_${index}`}
                                mode=""
                                products={this.props.user.userInfo.products}
                                currentUser={this.props.user.userInfo}
                                handleChange={this.handleProductChange}
                                product_id={product_id}
                            />
                        ))}
                    </div>

                    {!this.state.validation.product_ids && submitClicked ? (
                        <p className="error">Please choose at least one product. </p>
                    ) : null}

                    <div className="field-wrap">
                        <label
                            htmlFor="num_rows"
                            className={`labelactive ${!this.state.validation.num_rows && submitClicked ? 'error' : ''}`}
                        >
                            Show front
                            <span className="req">* </span>
                        </label>
                        <select name="num_rows" onChange={this.handleChange} value={this.state.num_rows || ''}>
                            <option value="18">18 rows </option>
                            <option value="12">12 rows </option>
                            <option value="9">9 rows </option>
                            <option value="6">6 rows </option>
                        </select>
                    </div>

                    <button
                        type="submit"
                        disabled={this.props.isViewSaving}
                        onClick={this.handleSubmit}
                        className="button button-block"
                    >
                        {mode === 'create' ? 'Create' : 'Update'}
                    </button>
                </form>
            </div>
        );
    }
}

ManageTabPopup.propTypes = {
    isViewSaving: PropTypes.bool.isRequired,
    hidePopup: PropTypes.func.isRequired,
    saveView: PropTypes.func.isRequired,
    user: PropTypes.shape({
        id: PropTypes.number,
        userInfo: PropTypes.shape({
            products: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }).isRequired,
    views: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    mode: PropTypes.string.isRequired,

    data: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        args: PropTypes.shape({
            order: PropTypes.number,
            num_rows: PropTypes.number,
            include: PropTypes.shape({
                products: PropTypes.arrayOf(PropTypes.number),
            }),
        }),
    }).isRequired,
};

export default ManageTabPopup;



// WEBPACK FOOTER //
// ./source/components/manageTapPopup.js